import { Injectable, computed } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';

@Injectable({
    providedIn: 'root'
})
export class SpinnerService {
    #spinners: SpinnerComponent[] = [];
    #defaultSpinner: SpinnerComponent;
    #pauseCount = 0;
    isActive = computed(() => this.#defaultSpinner ? this.#defaultSpinner?.isActive() : false);

    getSpinner(name: string = 'default') {
        for(const spinner of this.#spinners) {
            if (spinner?.name === name) {
                return spinner;
            }
        }
    }

    get defaultSpinner() {
        return this.#defaultSpinner;
    }

    start(message: string = '', delay: number = 0) {
        this.#defaultSpinner?.start(message, delay);
    }

    stop() {
        this.#defaultSpinner.stop();
    }

    update(message: string, fade = false) {
        this.#defaultSpinner?.update(message, fade);
    }

    registerSpinner(spinner: SpinnerComponent) {
        this.#spinners.push(spinner);
        if (spinner.isDefault) {
            this.#defaultSpinner = spinner;
        }
    }

    pause() {
        this.#defaultSpinner.paused = true;
        this.#pauseCount += 1;
    }

    unpause() {
        this.#pauseCount -= 1;
        if (this.#pauseCount === 0) {
            this.#defaultSpinner.paused = false;
        }
    }
}
